import React from "react";

/**
 * Tiny SVG sparkline for a rating series.
 * entries: [{at, stars}] chronological. Ignored if length < 2.
 */
export default function Sparkline({ entries, width = 80, height = 22, stroke = "#F59E0B" }) {
  if (!entries || entries.length < 2) return null;
  const points = entries.map(e => e.stars).filter(v => typeof v === "number");
  if (points.length < 2) return null;
  const min = 1, max = 5; // fixed 1-5 star scale
  const stepX = width / (points.length - 1);
  const y = (v) => height - ((v - min) / (max - min)) * (height - 4) - 2;
  const path = points.map((v, i) => `${i === 0 ? "M" : "L"} ${(i * stepX).toFixed(1)} ${y(v).toFixed(1)}`).join(" ");
  const last = points[points.length - 1];
  const first = points[0];
  const delta = last - first;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} data-testid="rating-sparkline"
         aria-label={`Rating trend: ${points.length} ratings, ${delta >= 0 ? "up" : "down"} ${Math.abs(delta).toFixed(1)} stars`}>
      <path d={path} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx={(points.length - 1) * stepX} cy={y(last)} r={2} fill={stroke}/>
    </svg>
  );
}
